import React, { Component } from 'react';
import { Select } from 'antd';

export enum States {
    all = -1,
    normal = 0,
    invalid = 1,
    forbbinden = 2,
    irresponsible = 11,
    quit = 12,
    retired = 13,
}

export enum StatesSelectorType {
    common = 0,
    customer = 1,
    company = 2,
}
interface StatesSelectProps {
    onChange?: (value: number | null) => void;
    selectorType?: StatesSelectorType;
    showAllOption?: boolean;
    initialValues?: number;
}

export const getStates = (states: States) => {
    switch (states) {
        case States.normal:
            return '正常';
        case States.invalid:
            return '失效';
        case States.forbbinden:
            return '禁用';
        case States.irresponsible:
            return '不负责培训';
        case States.quit:
            return '离职';
        case States.retired:
            return '退休';        
        default:
            return '其他';
    }
}

const getOptions = (selectorType: StatesSelectorType) => {
    let options;
    switch (selectorType) {
        case StatesSelectorType.customer:
            options = [
                { value: States.normal, label: '正常' },
                { value: States.invalid, label: '失效' },
                { value: States.irresponsible, label: '不负责培训' },
                { value: States.quit, label: '离职' },
                { value: States.retired, label: '退休' },
            ];
            break;
        case StatesSelectorType.company:
            options = [
                { value: States.normal, label: '正常' },
                { value: States.invalid, label: '失效' },
            ];
            break;
        default:
            options = [
                { value: States.normal, label: '正常' },
                { value: States.invalid, label: '失效' },
                { value: States.forbbinden, label: '禁用' },
            ];
            break;
    }
    return options;
}
class StatesSelect extends Component<StatesSelectProps> {
    showAllOption = this.props.showAllOption !== undefined ? this.props.showAllOption : true;
    selectorType = this.props.selectorType ? this.props.selectorType : StatesSelectorType.common;
    options = getOptions(this.selectorType);

    filteredOptions = this.showAllOption ? [{ value: -1, label: '全部' }, ...this.options] : this.options;

    handleStatesSelectChange = (value: any) => {
        this.props.onChange(value === -1 ? null : value);
    };
    render() {
        return (
            <>
                <Select className="select-states"
                        onChange={this.handleStatesSelectChange} 
                        placeholder="请选择状态"
                        defaultValue={this.props.initialValues ? this.props.initialValues : States.normal}
                >
                        {this.filteredOptions.map(option => (
                            <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                        ))}
                </Select>
            </>
        );
    }
};

export default StatesSelect;